export default {
  header: {
    title: 'Świetnie! Otrzymujesz bezpłatnie z zamówieniem:',
    subtitle: 'Zniżka zostanie zastosowana przy kasie.',
  },
  footer: {
    buttons: {
      no_thanks: 'Nie, dziękuję',
      add_to_basket: 'Dodaj do koszyka',
    },
  },
};
